import { apiFetch } from "../utils/apiFetch";
import React from "react";
import { useNavigate } from "react-router";
import { useQueryClient } from "@tanstack/react-query";

const WorkspaceLeave = ({
  currentUserRole,
  setWorkspaceLeavePopUp,
  workspaceLeavePopUp,
  workspace,
  setMembers,
}) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const handleExit = async () => {
    try {
      const res = await apiFetch(
        `${process.env.API_URL}/api/workspace/${workspace._id}/leave`,
        {
          method: "DELETE",
          },
      );

      if (!res.ok) throw new Error(res.status + ": " + res.statusText);

      const data = await res.json();

      setMembers((prev) =>
        prev.filter(
          (member) => String(member.userId._id) !== String(data.userId),
        ),
      );
      queryClient.clear();
      navigate("/courses");
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div
      onClick={() => setWorkspaceLeavePopUp(null)}
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[40dvw]  bg-white rounded-lg p-6"
      >
        <div className="flex flex-col gap-2 text-center sm:text-left">
          <h2 className="text-lg font-semibold">Exit group</h2>
          <p className="text-[#717182] text-sm">
            {currentUserRole !== "owner"
              ? "Are you sure you want to exit this group? you will lose access to all channels and messages."
              : "As there is only one owner per group, make someone else owner before you exit."}
          </p>
        </div>
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end mt-6">
          <button
            onClick={() => setWorkspaceLeavePopUp(null)}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive border bg-background text-foreground hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 h-9 px-4 py-2 has-[>svg]:px-3"
          >
            Cancel
          </button>
          <button
            onClick={handleExit}
            className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive text-white h-9 px-4 py-2 has-[>svg]:px-3 bg-red-600 hover:bg-red-700 focus:ring-red-600 ${currentUserRole === "owner" ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            Exit
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorkspaceLeave;
